const normalizeStatus = (value: unknown) =>
  String(value || "").trim().toLowerCase();

const isPendingStatus = (status: string) =>
  ["queued", "running", "snapshot_pending", "processing"].includes(status);

export const isQueuedOrRunningPrompt = (prompt: any) => {
  if (typeof prompt?.has_provider_run_in_progress === "boolean") {
    return prompt.has_provider_run_in_progress;
  }

  const providerStatuses =
    prompt?.provider_statuses && typeof prompt.provider_statuses === "object"
      ? Object.values(prompt.provider_statuses as Record<string, string>)
      : [];

  if (providerStatuses.length) {
    return providerStatuses.some((status) => {
      const normalized = normalizeStatus(status);
      return isPendingStatus(normalized);
    });
  }

  const normalized = normalizeStatus(
    prompt?.last_run_status ?? prompt?.lastRunStatus ?? prompt?.status ?? "",
  );
  return isPendingStatus(normalized);
};

const getPromptProviderStatuses = (prompt: any): string[] => {
  if (!prompt?.provider_statuses || typeof prompt.provider_statuses !== "object") {
    return [];
  }

  return Object.values(prompt.provider_statuses as Record<string, string>).map(
    (status) => normalizeStatus(status),
  );
};

const hasPromptMetricResult = (prompt: any) => {
  const rawVisibility = prompt?.visibility;
  if (rawVisibility !== null && rawVisibility !== undefined) {
    const visibility = Number(rawVisibility);
    if (Number.isFinite(visibility)) return true;
  }

  const position = Number(prompt?.position);
  if (Number.isFinite(position) && position > 0) return true;

  if (!Array.isArray(prompt?.positionsByRun)) return false;
  return prompt.positionsByRun.some((run: any) => {
    if (typeof run?.isMainMentioned === "boolean") return true;
    if (!run?.positions || typeof run.positions !== "object") return false;

    return Object.values(run.positions as Record<string, unknown>).some((value) =>
      Number.isFinite(Number(value)),
    );
  });
};

const hasAtLeastOneFinishedProvider = (prompt: any) => {
  const statuses = getPromptProviderStatuses(prompt);
  if (!statuses.length) return false;

  return statuses.some((status) => {
    if (!status) return false;
    return ![
      "queued",
      "running",
      "snapshot_pending",
      "processing",
      "not_triggered",
      "never_run",
    ].includes(status);
  });
};

export const isPromptMetricLoading = (prompt: any) => {
  if (!isQueuedOrRunningPrompt(prompt)) return false;
  if (hasPromptMetricResult(prompt)) return false;
  if (hasAtLeastOneFinishedProvider(prompt)) return false;
  return true;
};
